import React from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem
} from 'reactstrap';
import './Header.css';
import Logo from '../../assets/logo.png';
import {NavLink} from 'react-router-dom';

import {connect} from 'react-redux';


const mapStateToProps=state=>{
  return{
    token:state.token,

  }
}


const Header=props=>{
  let links=null;
  if(props.token===null){
    links=(
      <Nav className="mr-md-5">         
         <NavItem>
           <NavLink exact to="/login" className="NavLink">Login</NavLink>
         </NavItem>
       </Nav>
    )
  }
  else{
    links=(
      <Nav className="mr-md-5">
         <NavItem>
           <NavLink style={{
                backgroundColor:"#333",
                color:"white",
                borderRadius: "10px",
                display: "inline-block"               
               
           }}exact to="/" className="NavLink">BurgerBuilder</NavLink>
         </NavItem>
         <NavItem>
           <NavLink style={{
              backgroundColor:"#333",
              color:"white",                
                borderRadius: "10px",
                display: "inline-block" ,
                cursor:"pointer",              
               
           }} exact to="/orders" className="NavLink">Order</NavLink>
         </NavItem> 
         <NavItem>
           <NavLink style={{
              backgroundColor:"#333",
              color:"white",
                
                borderRadius: "10px",  
                display: "inline-block"             
               
           }}exact to="/logout" className="NavLink">Log Out</NavLink>
         </NavItem>        
       </Nav>
    )
  }
  return(
    <div className="Navigation">
     <Navbar style={{
       backgroundColor:"#333",
       height:"70px"
     }}>
       <NavbarBrand href="/" className="mr-auto ml-md-5">
         <img src={Logo} alt="Logo" width="50px"/>
       </NavbarBrand>
       {links}
     </Navbar>
    </div>
    )
}

export default connect(mapStateToProps)(Header);